import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TechHeroSection from './components/TechHeroSection';
import MaterialTechSection from './components/MaterialTechSection';
import ProductApplicationSection from './components/ProductApplicationSection';

export default function TechnologyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const techArticleSchema = {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: 'Daygreen의 업사이클링 소재 기술과 지속가능한 제작 공정',
    description: '폐기물을 새로운 가치로 전환하는 업사이클링 기술과 친환경 제작 공정',
    url: `${siteUrl}/technology`,
    inLanguage: 'ko-KR',
    author: {
      '@type': 'Organization',
      name: 'Daygreen',
    },
    about: [
      {
        '@type': 'Thing',
        name: '업사이클링 기술',
      },
      {
        '@type': 'Thing',
        name: '지속가능한 제작',
      },
      {
        '@type': 'Thing',
        name: '친환경 소재',
      },
    ],
  };

  return (
    <>
      <SEO
        title="기술 - Daygreen | 업사이클링 소재 기술과 지속가능한 제작 공정"
        description="Daygreen의 업사이클링 소재 기술, 친환경 제작 공정, 그리고 혁신적인 봉제 기술을 소개합니다. 폐기물을 새로운 가치로 전환하는 지속가능한 기술입니다."
        keywords="업사이클링 기술, 친환경 소재, 지속가능한 제작, 봉제 기술, 제로 웨이스트, 순환 경제, 친환경 공정"
        canonical="/technology"
        ogType="article"
      />
      <SchemaOrg schema={techArticleSchema} />
      <div className="min-h-screen">
        <Navbar />
        <TechHeroSection />
        <MaterialTechSection />
        <ProductApplicationSection />
        <Footer />
      </div>
    </>
  );
}